import React from "react";

const MobileFooter = () => {
  return (
    <div>
      <div class="footer">
        <p className="ied-mobile-footer">
          Powered By
          <strong className="netzerc">
            NETZERO<sup>®</sup>
          </strong>
          © <strong> IED</strong>
        </p>
        <div className="footer-logo">
          <img className="iedLogoFooter" src="/img/ied-logo.svg" alt="ied-logo" />
        </div>
      </div>
    </div>
  );
};

export default MobileFooter;
